export default "__VITE_ASSET__9cChMnuv__"